import { render, staticRenderFns } from "./VirtualTask.vue?vue&type=template&id=5fea3afd&scoped=true&"
import script from "./VirtualTask.vue?vue&type=script&lang=js&"
export * from "./VirtualTask.vue?vue&type=script&lang=js&"
import style0 from "./VirtualTask.vue?vue&type=style&index=0&id=5fea3afd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fea3afd",
  null
  
)

export default component.exports